export default __webpack_public_path__ + "static/media/seal-of-utah.a7fe70a9.svg";